import { PAGES } from '../lib/config';
import { AI_ENLARGER_FAQ } from '../lib/content';
import { ToolPageShell } from '../components/ToolPageShell';

export function AiImageEnlargerPage() {
  const page = PAGES.find((p) => p.path === '/ai-image-enlarger')!;
  const extra = (
    <>
      <h2 className="text-2xl font-bold text-text-primary">Enlarge images with AI</h2>
      <p>
        Our AI image enlarger increases the dimensions of your photos and graphics while helping
        maintain sharpness and detail.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">How it works</h3>
      <p>
        Upload an image, select 2× for free or 4× with Pro, and download the enlarged result in
        seconds.
      </p>
      <p>
        The AI model looks at edges, textures, and patterns to reconstruct a larger version that
        looks more natural than standard resizing.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">Best for</h3>
      <ul>
        <li>Product photos for online stores</li>
        <li>Profile pictures and portraits</li>
        <li>Marketing banners</li>
        <li>Old photos that need a larger print</li>
      </ul>
    </>
  );
  return <ToolPageShell page={page} faqItems={AI_ENLARGER_FAQ} extraContent={extra} />;
}
